import React from "react";
import { Tooltip, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import WhatsAppIcon from "@material-ui/icons/WhatsApp";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import LanguageIcon from "@material-ui/icons/Language";
import EmailIcon from "@material-ui/icons/Email";
import ChatBubbleOutlineIcon from "@material-ui/icons/ChatBubbleOutline";

const TikTokIcon = ({ style, ...props }) => (
  <svg viewBox="0 0 24 24" aria-hidden="true" {...props} style={{ width: ".9rem", height: ".9rem", ...style }}>
    <path fill="#25F4EE" d="M15.6 3.2c.4 2.2 1.7 3.7 3.8 4.2v3.2c-1.5-.1-2.8-.6-3.8-1.4v6.1c0 3.7-2.5 5.7-5.6 5.7-2.8 0-5.1-1.9-5.1-4.8 0-3 2.4-5 5.5-5.1v3.2c-1.3 0-2.2.7-2.2 1.8 0 1 .8 1.6 1.8 1.6 1.1 0 2.2-.7 2.2-2.6V3.2h3.4Z" />
    <path fill="#FE2C55" d="M17 2c.4 2.2 1.7 3.7 3.8 4.2v2.2c-1.5-.1-2.8-.6-3.8-1.4v6.1c0 3.7-2.5 5.7-5.6 5.7-.8 0-1.5-.2-2.1-.5.3.1.7.1 1 .1 1.1 0 2.2-.7 2.2-2.6V2H17Z" />
    <path fill="#111827" d="M15.6 2v11.3c0 1.9-1.1 2.6-2.2 2.6-1 0-1.8-.6-1.8-1.6 0-1.1.9-1.8 2.2-1.8V9.3c-3.1.1-5.5 2.1-5.5 5.1 0 2.9 2.3 4.8 5.1 4.8 3.1 0 5.6-2 5.6-5.7V7.8c1 .8 2.3 1.3 3.8 1.4V7.4C20.1 6.9 18.8 5.4 18.4 3.2V2h-2.8Z" />
  </svg>
);

const useStyles = makeStyles((theme) => ({
  badge: {
    display: "inline-flex",
    alignItems: "center",
    gap: 5,
    maxWidth: "100%",
    width: "fit-content",
    padding: "2px 6px 2px 4px",
    borderRadius: 999,
    backgroundColor: theme.palette.type === "dark" ? "rgba(255,255,255,.07)" : "#f7f8fa",
    border: `1px solid ${theme.palette.type === "dark" ? "rgba(255,255,255,.08)" : "#e8e9ee"}`,
    color: theme.palette.text.secondary,
    lineHeight: 1,
  },
  icon: { fontSize: ".9rem" },
  label: { fontSize: "0.68rem", fontWeight: 750, lineHeight: 1.2, whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" },
}));

const channelFrom = (ticket = {}) => {
  const source = `${ticket.channelDisplayName || ""} ${ticket.channelType || ""} ${ticket.channel || ""}`.toLowerCase();
  if (source.includes("instagram")) return { label: "Instagram", icon: InstagramIcon, color: "#c13584" };
  if (source.includes("facebook") || source.includes("messenger")) return { label: "Facebook", icon: FacebookIcon, color: "#1877f2" };
  if (source.includes("tiktok") || source.includes("tik tok")) return { label: "TikTok", icon: TikTokIcon, color: "#111827" };
  if (source.includes("web") || source.includes("website") || source.includes("live chat")) return { label: "Web", icon: LanguageIcon, color: "#0284c7" };
  if (source.includes("email") || source.includes("correo")) return { label: "Correo", icon: EmailIcon, color: "#64748b" };
  if (source.includes("whatsapp") || source.includes("waha") || source.includes("evolution") || source.includes("channel::api")) return { label: "WhatsApp", icon: WhatsAppIcon, color: "#16a34a" };
  return { label: ticket.channel || "Conversación", icon: ChatBubbleOutlineIcon, color: "#64748b" };
};

const ChannelBadge = ({ ticket }) => {
  const classes = useStyles();
  const channel = channelFrom(ticket);
  const Icon = channel.icon;

  return (
    <Tooltip title={`Canal conectado: ${channel.label}`} arrow>
      <span className={classes.badge}>
        <Icon className={classes.icon} style={{ color: channel.color }} />
        <Typography component="span" className={classes.label}>{channel.label}</Typography>
      </span>
    </Tooltip>
  );
};

export default ChannelBadge;
